import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 20px 10px 20px;
  position: relative;
  width: 360px;
  transition: transform 0.2s;
  margin: 10px 0 0px;

  @media (max-width: 930px) {
    max-width: 370px;
    padding-left: 10px;
  }
  @media (max-width: 540px) {
    max-width: 380px;
  }
  @media (max-width: 420px) {
    max-width: 340px;
  }
  @media (max-width: 380px) {
    max-width: 300px;
  }
  @media (max-width: 310px) {
    max-width: 250px;
  }
`;

export const Content = styled.div`
  box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 14px 8px 14px 0;
  width: 320px;
  height: 100px;
  background: ${({ theme }) => theme.backgroundCard};
  display: flex;
  align-items: center;

  position: relative;

  > span {
    min-width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      min-height: 65px;
      width: 65px;
    }
  }

  div {
    height: 100%;

    span {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      max-width: 145px;

      h1 {
        line-height: 30px;
        font-size: 1.25rem;
        font-weight: 600;
        margin: 0;
        color: ${({ theme }) => theme.text};
      }

      h2 {
        line-height: 25px;
        margin: 0;
        font-weight: 500;
        font-size: 1.25rem;
        color: ${({ theme }) => theme.text};

        &:nth-child(2) {
          margin-bottom: 10px;
        }
      }
    }
  }

  @media (max-width: 380px) {
    width: 260px;
    height: 130px;
    > span {
      img {
        height: 60px;
      }
    }
    div {
      min-width: 125px;
    }
  }

  @media (max-width: 310px) {
    width: 230px;
    height: 130px;
    div {
      span {
        h1 {
          font-size: 1.5rem;
        }
        h2 {
          font-size: 1rem;
        }
      }
      div {
        min-width: 125px;
      }
    }
  }

  > span {
    width: 80px;
    img {
      height: 50px;
    }
  }
`;

export const ButtonsContainer = styled.footer`
  position: absolute;

  right: 15px;
  top: calc(25px - 12px);

  display: flex;
  flex-direction: column;

  button {
    background: transparent;

    svg {
      color: ${({ theme }) => theme.green};
      height: 25px;
      width: 25px;
    }

    & + button {
      margin-top: 12px;
    }

    &:last-child {
      svg {
        color: ${({ theme }) => theme.red};
      }
    }
  }
`;
